export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10397.f5dd9117.jpg";